export default __webpack_public_path__ + "static/media/email01.f2e217b2.png";